const profileSecurityServiceName = "/ProfileSecurity";

export function profileSecurityService(http) {
    return {        
        setAsync: async (userId) => {
            var parameterContainer = {
                userId: userId
            }
            return await http.post(profileSecurityServiceName + "/SetAsync", parameterContainer);
        },
        check: async (userId, code) => {
            var parameterContainer = {
                userId: userId,
                code: code
            }
            return await http.post(profileSecurityServiceName + "/Check", parameterContainer);
        },
        remove: (userId) => {
            var parameterContainer = {
                userId: userId
            }
            return http.post(profileSecurityServiceName + "/Remove", parameterContainer);
        }
    }
}
